var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBianjiHongqiXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.78l1.635-.245a8.322 8.322 0 013.62.258v0c1.116.334 2.29.43 3.445.282l2.17-.278a.149.149 0 00.13-.148v-6.5a.104.104 0 00-.126-.101l-2.15.473a5.854 5.854 0 01-3.462-.294v0a5.854 5.854 0 00-3.658-.247l-1.305.335A.398.398 0 002.5 2.7v6.08zm0 0v5.72",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/bianji_hongqi_xian.707403b9.svg";
export { SvgBianjiHongqiXian as ReactComponent };